import { ApiIntegrationCreateAndPublishPingPaymentAgreementPostRequest, ApiIntegrationCreatePaymentLinkPostRequest, IntegrationApi, WebApiIntegrationsDtoConnectIntegrationDto, WebApiIntegrationsDtoCreateAgreementDto, WebApiIntegrationsDtoCreateMultiplePaymentLinkDto, WebApiIntegrationsDtoCreatePaymentLinkDto } from "../Repository/eventbookyapi";
import { IntegrationType } from "../Types/IntegrationType";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class IntegrationService {
    public static GetIntegration = async (type: IntegrationType) => {
        return new IntegrationApi(GetApiConfiguration()).apiIntegrationGet({ type });
    };

    public static GetActiveIntegrations = async () => {
        return new IntegrationApi(GetApiConfiguration()).apiIntegrationGetActiveIntegrationsGet();
    };

    public static GetInvoices = async (type: IntegrationType) => {
        return new IntegrationApi(GetApiConfiguration()).apiIntegrationGetInvoicesGet({ type });
    };

    public static CreatePaymentLink = async (request: WebApiIntegrationsDtoCreatePaymentLinkDto) => {
        return new IntegrationApi(GetApiConfiguration()).apiIntegrationCreatePaymentLinkPost({ webApiIntegrationsDtoCreatePaymentLinkDto: request });
    };

    public static CreateMultiplePaymentLinks = async (request: WebApiIntegrationsDtoCreateMultiplePaymentLinkDto) => {
        return new IntegrationApi(GetApiConfiguration()).apiIntegrationCreateMultiplePaymentLinksPost({ webApiIntegrationsDtoCreateMultiplePaymentLinkDto: request });
    };

    public static CancelPaymentLink = async (paymentUrl: string) => {
        return new IntegrationApi(GetApiConfiguration()).apiIntegrationCancelPaymentLinkDelete({ paymentUrl });
    };

    public static RemoveIntegration = async (id: number) => {
        return new IntegrationApi(GetApiConfiguration()).apiIntegrationDelete({ integrationId: id });
    };

    public static ConnectIntegration = async (dto: WebApiIntegrationsDtoConnectIntegrationDto) => {
        return new IntegrationApi(GetApiConfiguration()).apiIntegrationPost({
            webApiIntegrationsDtoConnectIntegrationDto: dto
        });
    };

    public static CreateAndPublishPingPaymentAgreement = async (dto: WebApiIntegrationsDtoCreateAgreementDto) => {
        return new IntegrationApi(GetApiConfiguration()).apiIntegrationCreateAndPublishPingPaymentAgreementPost({
            webApiIntegrationsDtoCreateAgreementDto: dto
        });
    };
};